import EntityApi from "../Api/EntityApi";

class RegisteredListService {

    constructor(jsonApi, state) {
        this.entityApi = new EntityApi(jsonApi);
        this.jsonApi = jsonApi;
        this.state = state;

        this.state.add('runners', []);
        this.state.add('modificationTime', 0);
        this.state.add('loading', true);
        this.state.add('error', '');

        this.state.add('sorting', 'lastName');
        this.state.add('sortingDirection', 'asc');
        this.state.add('sortingAttributeType', 'string');
    }

    fetchRunners() {
        this.state.setLoading(true);
        this.state.setError('');
        this.entityApi.list('Runner', 'publicRegisterlist',
            (resultType, list, data) => {
                if (data.status === 'success') {
                    this.state.setModificationTime(data.data.modified);
                    this.updateRunners(list);
                }

                this.state.setLoading(false);
            },
            (res) => {
                if (res.status !== 'nochange') {
                    console.log('fetch failed:' + res.message);
                    this.state.setError(res.message);
                }
                this.state.setLoading(false);
            },
            -1); //this.state.modificationTime);
    }

    sortRunners() {
        let sortarr = this.state.runners;
        sortarr = sortarr.sort((a, b) => {
            const [c, d] = this.state.sortingDirection === 'asc' ? [a, b] : [b, a];
            if (this.state.sorting === 'lastName') {
                const eDiff= String(c.lastName).localeCompare(d.lastName);
                return eDiff !== 0 ? eDiff :  String(c.firstName).localeCompare(d.firstName);
            }
            if (this.state.sortingAttributeType === 'int')
                return c[this.state.sorting] - d[this.state.sorting];
            if (this.state.sortingAttributeType === 'string')
                return String(c[this.state.sorting]).localeCompare(d[this.state.sorting]);
            if (this.state.sortingAttributeType === 'bool')
                return c[this.state.sorting] === d[this.state.sorting] ? 0 : (c[this.state.sorting] ? 1 : -1);
            if (this.state.sortingAttributeType === 'object') {
                const e = c[this.state.sorting] ? c[this.state.sorting].name : 'ööö';
                const f = d[this.state.sorting] ? d[this.state.sorting].name : 'ööö';
                return String(e).localeCompare(f);
            }

        });

        return sortarr;
    }

    updateRunners(list) {
        this.state.setRunners(list.sort((a, b) => a.lastName - b.lastName));
    }

}

export default RegisteredListService;